var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TPTable',{attrs:{"show-only-uuid":_vm.item.uuid},on:{"refresh":function($event){return _vm.$emit('refresh')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }